[{
        "coreStep": "Market Quoting",
        "generalTask": "Send to Markets",
        "actionDetails": "<ul><li> Send submission to markets using Template Text<\/li><li> Include contract draft, with the redline version for expiring markets only<\/li><\/ul>",
        "responsibility": "BT\/OS\/OD",
        "cemRequirement": "Yes",
        "guidanceReferenceLink": ""
    },
    {
        "coreStep": "Market Quoting",
        "generalTask": "Create & Update Quote Sheet",
        "actionDetails": "<ul><li> Create quote sheet, capturing all markets receiving the submission<\/li><li>Update the quote sheet as quotes are received and include any \/ all subjectivities and \/ or non-concurrencies<ul><li><b>Secure market agreement to contractual language for all subjectivities and non-concurrencies prior to presenting to Client.<\/b><\/li><li>Any market binding requirements such as date<\/li><\/ul><\/li><\/ul>",
        "responsibility": "BT",
        "cemRequirement": "No",
        "guidanceReferenceLink": "<a href=\"https:\/\/ajg0.sharepoint.com\/sites\/gre-Gateway\/_layouts\/15\/download.aspx?UniqueId=fe24d972%2D0abc%2D4437%2Da00b%2De78f08e75de7\" target=\"_self\" rel=\"noopener\">Non-Concurrency Handling<\/a>"
    }
]